import { render, staticRenderFns } from "./two_factor_email_fallback.vue?vue&type=template&id=c84557d4"
import script from "./two_factor_email_fallback.vue?vue&type=script&lang=js"
export * from "./two_factor_email_fallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports